<template>
  <q-page class="q-pa-md q-gutter-md">
    <section>
      <p class="text-h5">Paleta de cores</p>
      <div class="row q-col-gutter-md">
        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-primary my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> primary
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-secondary my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> secondary
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-accent my-card-section"> </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> accent
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-positive my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> positive
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-negative my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> negative
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-warning my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> warning
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-info my-card-section"> </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> info
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-1 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-1
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-2 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-2
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-3 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-3
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-4 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-4
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-5 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-5
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-6 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-6
              </span>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-2">
          <q-card>
            <q-card-section class="bg-brand-7 my-card-section">
            </q-card-section>
            <q-card-section>
              <span class="text-body-1">
                <span class="text-weight-bold">class:</span> brand-7
              </span>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>

    <q-separator />
    <section>
      <p class="text-h5">Tipografia</p>
      <div class="row q-col-gutter-md">
        <div class="col-xs-12 col-sm-6">
          <q-card>
            <q-card-section>
              <div class="text-subtitle1">Font weight</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <q-list>
                <q-item>
                  <q-item-section>
                    <q-item-label>Aa</q-item-label>
                    <q-item-label caption>font-family: Inter</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular"
                      >Regular</q-item-label
                    >
                    <q-item-label caption
                      >class: text-weight-regular</q-item-label
                    >
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-medium"
                      >Medium</q-item-label
                    >
                    <q-item-label caption
                      >class: text-weight-medium</q-item-label
                    >
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-bold"
                      >SemiBold</q-item-label
                    >
                    <q-item-label caption>class: text-weight-bold</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-bolder">Bold</q-item-label>
                    <q-item-label caption
                      >class: text-weight-bolder</q-item-label
                    >
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-12 col-sm-6">
          <q-card>
            <q-card-section>
              <div class="text-subtitle1">Font size</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <q-list>
                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular text-h5"
                      >23px</q-item-label
                    >
                    <q-item-label caption>class: text-h5</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular text-h6"
                      >19px</q-item-label
                    >
                    <q-item-label caption>class: text-h6</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular text-body"
                      >16px</q-item-label
                    >
                    <q-item-label caption>class: text-body</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular text-body2"
                      >14px</q-item-label
                    >
                    <q-item-label caption>class: text-body2</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section>
                    <q-item-label class="text-weight-regular text-caption"
                      >12px</q-item-label
                    >
                    <q-item-label caption>class: text-caption</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>

    <q-separator />
    <section>
      <p class="text-h5">Iconografia</p>
      <div class="row q-col-gutter-md">
        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Editar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="edit" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="edit"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Deletar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="delete" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="delete"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Pesquisa</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="search" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="search"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Date</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="event" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="event"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Adicionar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="add_circle_outline" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">
                name="add_circle_outline"
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Anexar arquivo</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="attach_file" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="attach_file"</div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Finalizar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="check_circle_outline" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">
                name="check_circle_outline"
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Confirmar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="done" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="done"</div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Filtrar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="filter_alt" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="filter_alt"</div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Exportar</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="file_upload" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="file_upload"</div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-3">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Imprimir</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="print" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="print"</div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-xs-4">
          <q-card>
            <q-card-section class="row justify-center">
              <div>Remover</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="remove_circle_outline" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">
                name="remove_circle_outline"
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-4">
          <q-card>
            <q-card-section class="row justify-center">
              <div>vpn_key</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="vpn_key" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="vpn_key"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-4">
          <q-card>
            <q-card-section class="row justify-center">
              <div>settings</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="settings" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="settings"</div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-xs-4">
          <q-card>
            <q-card-section class="row justify-center">
              <div>qr_code</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <q-icon name="qr_code" size="xl" />
            </q-card-section>
            <q-separator />
            <q-card-section class="row justify-center">
              <div class="text-caption text-brand-6">name="qr_code"</div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>

    <q-separator />
    <section>
      <p class="text-h5">Botões</p>
      <div class="row q-col-gutter-md">
        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Confirmação/Finalização</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <q-btn
                color="positive"
                label="Salvar"
                icon="check_circle_outlined"
                no-caps
              />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: color="positive" label="xxxx" icon="xxxx" no-caps
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Filtro/Adição</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <q-btn
                color="primary"
                label="Adicionar"
                icon="add_circle_outlined"
                no-caps
              />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: color="primary" label="xxxx" icon="xxxx" no-caps
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Mudando de estado</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <q-btn
                style="width: 200px"
                :text-color="estado ? 'black' : ''"
                :color="estado ? 'accent' : 'primary'"
                :label="estado ? 'Selecionado' : 'Selecionar   '"
                no-caps
                dense
                @click="estado = !estado"
                :icon="estado ? 'check_circle_outline' : 'add_circle_outline'"
              />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: color="xxx" label="xxxx" icon="xxxx" style="200px"
                no-caps
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Upload de Arquivos</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div
                class="row col-12 text-brand-5 text-weight-bold q-gutter-x-sm container-input-file"
              >
                <div class="container">
                  <label class="btn info" for="arquivo">
                    Selecionar Arquivo</label
                  >
                  <input id="arquivo" type="file" @change="onFileSelected" />
                  <span class="icon">
                    <img src="../assets/file_upload_black.svg" alt="" />
                  </span>
                </div>
              </div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: outlined dense label="xxx" bg-color="primary"
                label-color="white" icon: attach_file
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>

    <q-separator />
    <section>
      <p class="text-h5">Input</p>
      <div class="row q-col-gutter-md">
        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Text</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <label for="text">Text</label>
              <q-input for="text" type="text" outlined dense />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: type="text" outlined dense
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Text disable</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <label for="">Text disable</label>
              <q-input
                v-model="model"
                class="bg-brand-7"
                type="text"
                outlined
                dense
                disable
              />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: type="text" outlined dense disable; class:
                bg-brand-7
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Select</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <label for="">Select</label>
              <q-select v-model="model" :options="options" outlined dense />
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: outlined dense
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Pesquisa</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <label for="">Pesquisa</label>

              <q-input
                dense
                debounce="300"
                v-model="filter"
                placeholder="Pesquisar"
              >
                <template v-slot:append>
                  <q-icon name="search"></q-icon>
                </template>
              </q-input>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: outlined dense
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Radio</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div>Radio</div>

              <q-radio
                v-model="resposta.resposta"
                val="true"
                label="Sim"
              ></q-radio>
              <q-radio
                v-model="resposta.resposta"
                val="false"
                label="Não"
              ></q-radio>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                <p></p>
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-xs-4">
          <q-card>
            <q-card-section>
              <div>Datepicker</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <label>Datepicker</label>
              <q-input
                dense
                outlined
                placeholder="DD/MM/AAAA"
                v-model="date.data"
                mask="##/##/####"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        mask="DD/MM/YYYY"
                        v-model="date.data"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </q-card-section>
            <q-separator />
            <q-card-section>
              <div class="text-caption text-brand-6">
                properties: outlined dense mask="##/##/####" icon:event
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>

    <q-separator />
    <section>
      <p class="text-h5">Tabelas</p>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        dense
        class="tabela-tamanho-fixo"
        :columns="columns"
        row-key="name"
        v-model:pagination="pagination"
        hide-pagination
      />

      <div class="row justify-start q-mt-md">
        <q-pagination
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
    <section>
      <p class="text-h5">Componentes</p>
      <div class="row q-col-gutter-md">
        <div class="col-xs-6 col-sm-3 col-md-7">
          <q-card>
            <q-card-section>
              <span> Assinatura </span>
            </q-card-section>
            <div class="row col-12 justify-center">
              <Canvas />
            </div>
            <q-card-section>
              <div class="text-body-1">
                <span class="text-weight-bold">props:</span> restart="int"
                go="int"
              </div>
              <div class="text-body-1">
                <span class="text-weight-bold">emits:</span>
                @update="null"
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-xs-6 col-sm-3 col-md-4">
          <q-card>
            <q-card-section>
              <span> Biometria </span>
            </q-card-section>
            <q-card-section class="row col-12 justify-center">
              <q-img
                class="img-biometria"
                src="../assets/bioRequest.png"
                @click="modal = !modal"
              />
              <Biometria :modal="modal" :titulo="'Biometria'" />
            </q-card-section>
            <q-card-section>
              <div class="text-body-1">
                <span class="text-weight-bold">props:</span> modal="boolean"
                titulo="string" userId="int" tipoBiometria="cadastro/biometria"
              </div>
              <div class="text-body-1">
                <span class="text-weight-bold">emits:</span>
                @atualizarBiometrias="null" @negativePrint="string"
                @resultadoVerificacao="boolean"
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12">
          <q-card>
            <q-card-section>
              <span>Gráficos</span>
            </q-card-section>
            <div class="row col-12 justify-center">
              <BarChart
                :labels="dadosGrafico.labels"
                :datasets="dadosGrafico.datasets"
              />
            </div>
            <q-card-section>
              <div class="text-body-1">
                <span class="text-weight-bold">props:</span> labels="array"
                dataSets="array"
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
import { ref, computed } from "vue";
import Biometria from "../modules/biometria/views/Biometria.vue";
import Canvas from "../modules/ferramentasAdm/components/Canvas.vue";
import BarChart from "../modules/legado/treinamento/components/BarChart.vue";

const columns = [
  { name: "name", label: "Name", field: "name", align: "left", sortable: true },
  { name: "calories", label: "Calories", field: "calories" },
  { name: "fat", label: "Fat", field: "fat" },
  { name: "carbs", label: "Carbs", field: "carbs" },
];

const rows = [
  {
    name: "Frozen Yogurt",
    calories: 159,
    fat: 6.0,
    carbs: 24,
  },
  {
    name: "Ice cream sandwich",
    calories: 237,
    fat: 9.0,
    carbs: 37,
  },
  {
    name: "Eclair",
    calories: 262,
    fat: 16.0,
    carbs: 23,
  },
  {
    name: "Cupcake",
    calories: 305,
    fat: 3.7,
    carbs: 67,
  },
  {
    name: "Gingerbread",
    calories: 356,
    fat: 16.0,
    carbs: 49,
  },
  {
    name: "Jelly bean",
    calories: 375,
    fat: 0.0,
    carbs: 94,
  },
  {
    name: "Lollipop",
    calories: 392,
    fat: 0.2,
    carbs: 98,
  },
  {
    name: "Honeycomb",
    calories: 408,
    fat: 3.2,
    carbs: 87,
  },
  {
    name: "Donut",
    calories: 452,
    fat: 25.0,
    carbs: 51,
  },
  {
    name: "KitKat",
    calories: 518,
    fat: 26.0,
    carbs: 65,
  },
];

export default {
  components: {
    Biometria,
    Canvas,
    BarChart,
  },
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 3,
      // rowsNumber: xx if getting data from a server
    });
    const date = ref({
      data: "",
    });
    const resposta = ref({
      resposta: "",
    });
    let estado = ref(false);
    let modal = ref(false);
    const dadosGrafico = ref({
      labels: ["Dado 1", "Dado 2", "Dado 3", "Dado 44", "Dado 5", "Dado 6"],
      datasets: [
        {
          label: "Teste",
          data: [10, 20, 3, 5, 6, 8],
          backgroundColor: ["#FDFF00"],
        },
      ],
    });

    return {
      model: ref(null),
      options: ["Unidade 1", "Unidade 2"],
      columns,
      rows,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(rows.length / pagination.value.rowsPerPage)
      ),
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      date,
      resposta,
      estado,
      modal,
      dadosGrafico,
    };
  },
};
</script>

<style scoped>
.my-card-section {
  height: 90px;
}
input[type="file"] {
  display: none;
}
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
  cursor: pointer;
  border-color: #2196f3;
  color: #58afc1;
}
.info {
  border-color: #58afc1;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: -2px;
  left: 9px;
}
.img-biometria {
  height: 100px;
  width: 100px;
  cursor: pointer;
}
</style>
